const initials = "cards/";

export const UPDATE_CARD_REDUCER = `${initials}UPDATE_CARD_REDUCER`;